import { DocumentFile } from '@nextforce/api'
import * as DocumentPicker from 'expo-document-picker'

export type DocumentResult =
  | {
      status: 'cancelled'
    }
  | {
      status: 'success'
      files: DocumentFile[]
    }

export const PDF_MIME_TYPE = 'application/pdf'

export async function pickDocument(
  type?: string | string[],
  multiple: boolean = true
): Promise<DocumentResult> {
  const result = await DocumentPicker.getDocumentAsync({
    type: type ?? PDF_MIME_TYPE,
    copyToCacheDirectory: false,
    multiple,
  })

  if (result.canceled) {
    return { status: 'cancelled' }
  }
  const assets = result.assets
  const files: DocumentFile[] = []
  for (const asset of assets) {
    files.push({
      ...asset,
      type: 'document',
      mimeType: type && asset.mimeType ? asset.mimeType : PDF_MIME_TYPE,
    })
  }
  return {
    status: 'success',
    files,
  }
}
